import { Merge, MoreHorizontal, Palette, Pencil, Share2, Sparkles, Trash2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { isGuest } from "@/lib/guest";

// Secondary album actions behind one "…" button so the header row stays compact.
export const AlbumMenu = ({ album, onShare, onRename, onConvert, onRemove, onTheme, onMerge }) => {
  const rows = [
    album.can_edit && [Share2, album.share_enabled ? "Sharing link…" : "Share link…", onShare, "album-share-button"],
    album.can_edit && [Pencil, "Rename", onRename, "album-rename-button"],
    album.can_theme && [Palette, "Theme", onTheme, "album-theme-button"],
    !isGuest() && album.can_change_visibility && [Merge, "Merge into…", onMerge, "album-merge-button"],
    album.can_edit && album.smart && [Sparkles, "Make regular", onConvert, "album-convert-button"],
    album.can_edit && [Trash2, album.smart ? "Hide album" : "Delete album", onRemove, "album-delete-button"],
  ].filter(Boolean);
  if (!rows.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="tool-btn" aria-label="More album actions" data-testid="album-menu-button"><MoreHorizontal size={16} /></button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {rows.map(([Icon, label, fn, tid]) => (
          <DropdownMenuItem key={tid} onClick={fn} data-testid={tid}><Icon size={14} className="mr-2" />{label}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
